import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./report_type.js";
//#region src/report_type_helper.ts
var report_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(reportType) {
	switch (reportType) {
		case "coupon-redemption-history": return "Coupon Redemption History";
		case "customer-orders": return "Customer Orders";
		case "day-upsell": return "Upsell by Day (internal only)";
		case "eighty-sixing-activity": return "86ing Activity";
		case "flash-payouts": return "Flash Payouts (Live Stripe Accounts Only)";
		case "future-orders": return "Future Orders";
		case "industry-benchmark": return "Industry Benchmark (internal only)";
		case "item-upsell": return "Recommended Items";
		case "kiosk-usage-overlap": return "Kiosk Usage Overlap (internal only)";
		case "kiosk-peripherals": return "Kiosk Peripherals";
		case "kiosk-order-ready": return "KOR";
		case "loyalty-login-attempts": return "Loyalty Login Attempts";
		case "loyalty-signups": return "Loyalty Signups";
		case "loyalty-usage": return "Loyalty Usage";
		case "order-conversion-rate": return "Order Conversion Rate";
		case "order-insertion-rate": return "Order Insertion Rate";
		case "pilot-engagement": return "Pilot Engagement";
		case "pilot-labor-analysis": return "Pilot Labor Analysis";
		case "punchh-location-orders": return "Punchh Location Orders";
		case "sales-guests": return "Order & Guest Engagement Data";
		case "sales-orders": return "Order Breakdown Data";
		case "sales-summary-channel": return "Channel Summary";
		case "sales-summary-modal": return "Sales Summary";
		case "sales-summary-org": return "Org Summary";
		case "sales-summary-site": return "Site Summary";
		case "sales-transactions": return "Transactions Data";
		case "third-party-orders": return "Third Party Orders";
		case "vendor-payouts": return "Vendor Payouts (Live Stripe Accounts Only)";
		case "vitrine-session-metrics": return "Vitrine Session Metrics";
	}
}
//#endregion
export { name, report_type_helper_exports };

//# sourceMappingURL=report_type_helper.js.map